<script>
  import { DropdownItem } from '@sveltestrap/sveltestrap';

  export let name = '';
  export let files = [];
  export let selectable = false;
  export let selected = [];
  export let onSelect = () => {};
  export let meta = {};
</script>

<DropdownItem header class="level-2 {files.length ? 'group' : ''}">
  <label for={meta.id}>
    <i class:os-icon-folder-minus={files.length} class:os-icon-folder={!files.length} />
    {#if selectable}
      <input type="checkbox" id={meta.id} checked={selected.includes(meta.id)} on:change={(e) => onSelect(e, meta)} />
    {/if}
    <span>{name}</span>
  </label>
</DropdownItem>

{#each files as file}
  <DropdownItem header class="level-3 {file.files.length ? 'group' : ''}">
    <label for={file.id}>
      <i class:os-icon-folder-minus={file.files.length} class:os-icon-folder={!file.files.length} />
      {#if selectable}
        <input type="checkbox" id={file.id} checked={selected.includes(file.id)} on:change={(e) => onSelect(e, file)} />
      {/if}
      <span>{file.name}</span>
    </label>
  </DropdownItem>
  {#each file.files as subfile}
    {#if subfile.files}
      <DropdownItem header class="level-4 {subfile.files.length ? 'group' : ''}">
        <label for={subfile.id}>
          <i class:os-icon-folder-minus={subfile.files.length} class:os-icon-folder={!subfile.files.length} />
          {#if selectable}
            <input
              type="checkbox"
              id={subfile.id}
              checked={selected.includes(subfile.id)}
              on:change={(e) => onSelect(e, subfile)}
            />
          {/if}
          <span>{subfile.name}</span>
        </label>
      </DropdownItem>

      {#each subfile.files as subsubfile}
        <DropdownItem header class="level-5 {subsubfile.files.length ? 'group' : ''}">
          <label for={subsubfile.id}>
            <i class:os-icon-folder-minus={subsubfile.files.length} class:os-icon-folder={!subsubfile.files.length} />
            {#if selectable}
              <input
                type="checkbox"
                id={subsubfile.id}
                checked={selected.includes(subsubfile.id)}
                on:change={(e) => onSelect(e, subsubfile)}
              />
            {/if}
            <span>{subsubfile.name}</span>
          </label>
        </DropdownItem>
      {/each}
    {:else}
      <DropdownItem>
        <label for={subfile.id}>
          {#if selectable}
            <input
              type="checkbox"
              id={subfile.id}
              checked={selected.includes(subfile.id)}
              on:change={(e) => onSelect(e, subfile)}
            />
          {/if}
          <span>{subfile.name}</span>
        </label>
      </DropdownItem>
    {/if}
  {/each}
{/each}

<style lang="scss" src="./menu.scss"></style>
